import React from 'react';
import { Container, Row, Col, Badge } from 'react-bootstrap';
import toast from "react-hot-toast";

const gameList = [

  { name: 'All Games', icon: '/assets/icon/56.png' },
  { name: 'Cricket', icon: '/assets/all_images/sidebar/s11.webp' },
  { name: 'Football', icon: '/assets/all_images/sidebar/s6.webp' },
  { name: 'Tennis', icon: '/assets/all_images/sidebar/s8.webp' },

];

const InPlayCom = ({ selectedGame, setSelectedGame, matchCount = {} }) => {
  const handleClicktoast = () => {
    toast.success("Coming soon");
  };

  return (
    <>
      <style>{`
        .active {
          display: flex;
          flex-direction: column;
        }
      `}</style>

      <div className="inplay-container">
        <div className="inplay-header">In-Play</div>
        <Container fluid className="inplay-body py-2 px-3">
          <Row className="justify-content-start">
            {gameList.map((game, index) => {
              const count = matchCount?.[game.name] ?? null;

              return (
                <Col
                  key={index}
                  xs="auto"
                  className={`text-center position-relative mb-0 mx-2 ${selectedGame === game.name ? 'active' : ''}`}
                  onClick={() => {
                    setSelectedGame(game.name);
                    if (game.name === 'Horse' || game.name === 'GreyHound') {
                      handleClicktoast?.();
                    }
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="game-icon-wrapper">
                    <img
                      src={game.icon}
                      alt={game.name}
                      className="game-icon"
                    />
                    {count > 0 && (
                      <Badge bg="danger" className="game-badge">
                        {count}
                      </Badge>
                    )}
                  </div>
                  <div className="game-label">{game.name}</div>
                </Col>
              );
            })}
          </Row>
        </Container>
      </div>
    </>
  );
};

export default InPlayCom;
